import ApiService from '../services/ApiService';

export default class UserReportRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    getUserReport() {
        return this.apiService.get('user-report-export', {
            responseType: 'blob'
        });
    }
}
